(
    function ($)
    {
    $.skyserial = {
        bound: {
            read: [],
            readHandle: []
        },
        defaults: {
            host: "https://localhost:3001",
            portName: "COM1",
            baudRate: 9600,
            dataBits: 8, /* Options: 4, 5, 6, 7, 8 */
            parity: "None", /* Options: None, Odd, Even, Mark, Space */
            stopBits: "One" /* Options: None, One, Two, OnePointFive */
        },
        /* Description:
        *  attach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  options:  map of data that will be passed to $.skyserial method
        *  callback: function to execute each time the method responds
        */
        bind: function (method, options, callback) {
            function bindRead(method, options, callback, handle) {
                var index = $.inArray(callback, $.skyserial.bound.read);

                if (index != -1 && $.skyserial.bound.readHandle[index] == handle) {
                    $.skyserial.read(options, function (response) {
                        if (response.status != 504) {
                            callback(response);
                        }
                        setTimeout(function () {
                            bindRead(method, options, callback, handle);
                        }, response.status == 200 || response.status == 504 ? 0 : 8000);
                    });
                }
            }

            if (method == "read")
            {
                var index = $.inArray(callback, $.skyserial.bound.read);

                if (index == -1) {
                    var handle = 1;
                    $.skyserial.bound.read.push(callback);
                    $.skyserial.bound.readHandle.push(handle);
                    bindRead(method, options, callback, handle);
                }
                else {
                    var handle = $.skyserial.bound.readHandle[index];
                    bindRead(method, options, callback, handle);
                }
            }
        },
        /* Description:
        *  detach a continous handler to one of the $.skyserial methods
        * Options: 
        *  method:   the $.skyserial method ('read' is the only option at this time)
        *  callback: function that is to be no longer executed (optional, if not supplied all are removed)
        */
        unbind: function (method, callback) {
            if (method == "read") {
                if (callback) {
                    var index = $.inArray(callback, $.skyserial.bound.read);
                    if (index != -1) {
                        $.skyserial.bound.readHandle[index]++;
                    }                    
                }
                else {
                    $.skyserial.bound.readHandle.each(function (index) {
                        $.skyserial.bound.readHandle[index]++;
                    });
                }
            }
        },
        /* Description:
        *  reads bytes from the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        read: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax({
                url: settings.host + "/read",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                dataType: "jsonp",
                activityIndicator: { silent: true },
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                }
            });
        },
        /* Description:
        *  write an array of bytes to the serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        *  bytes:    byte array to be written to the serial port
        */
        write: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);

            $.ajax({
                url: settings.host + "/write",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                traditional: true,
                timeout: 8000,
                dataType: "jsonp",
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        },
        /* Description:
        *  check on the status of the service without reading or writing to serial port, callback is optional
        * Options: 
        *  host:     see $.skyserial.defaults.host
        *  portName: see $.skyserial.defaults.portName
        *  baudRate: see $.skyserial.defaults.baudRate
        *  dataBits: see $.skyserial.defaults.dataBits
        *  parity:   see $.skyserial.defaults.parity
        *  stopBits: see $.skyserial.defaults.stopBits
        */
        status: function (options, callback) {
            var settings = $.extend({}, $.skyserial.defaults, options);
            $.ajax({
                url: settings.host + "/status",
                headers: {
                    "Content-Security-Policy": "script-src-elem 'self' 'unsafe-inline' 'unsafe-eval'"
                },
                data: settings,
                dataType: "jsonp",
                timeout: 8000,
                success: function (data, jqXHR, textStatus) {
                    if (callback) {
                        callback(data);
                    }
                },
                error: function () {
                    if (callback) {
                        callback({
                            status: 404,
                            message: "Unable to connect to SkySerial. Please check to ensure you have SkySerial installed and running in your Windows system task tray."
                        });
                    }
                }
            });
        }
    };
})(jQuery);